<script>
  import { onMount } from 'svelte'
  import Button from '@components/Button.html';
  import { bindAction } from '@store'
  import { randomInteger } from '@help'
  import ListimBtn from '@components/ListimBtn'
  export let img,
    href,
    imgWidth,
    maxHeight,
    alt,
    imgDescription,
    description,
    title,
    dateFrom,
    dateTo,
    time,
    timeDate,
    pay,
    box,
    exchangeTitle,
    titleTop,
    importantDate,
    square,
    rectangle,
    type,
    listim_id,
    dateExclude,
    hoverType='paddings',
    descClassNames,
    onClick,
    clickData;

  let error = false, preload = true, errorImage
  let errorHandle = () => error = true
  let hidePreload = () => preload = false
  const onClickHandler = () => {
    if (onClick && typeof onClick === 'function') {
      onClick(clickData)
    }
  }
</script>
<div
  class="tile position-relative"
  style="width: {(imgWidth && imgWidth+'px') || '100%'};"
  class:scaleHover={hoverType === 'scale'}
  on:click={onClickHandler}
>
  <a class="tile_link d-block" href={href || '/'}>
    {#if titleTop && title}
      <div class="tile_title height-const">
        <span>{title}</span>
      </div>
    {/if}
    <div
      class="tile_img position-relative"
      class:rectangle={type === 'rectangle'}
      class:square={type === 'square'}
      class:default={type === 'default'}
      class:vertical={type === 'vertical'}
      class:error={error}
      class:preload={preload}
      style="max-width: {(imgWidth && imgWidth+'px') || '100%'}"
    >
      <img
        src={img}
        alt={alt || 'Изображение'}
        class="d-block"
        style="max-height: {(maxHeight && maxHeight + 'px') || '100%'}"
        on:error={errorHandle}
        on:load={hidePreload}
      />
      {#if imgDescription}
        <div class="img-descirption position-absolute">
          <span>{imgDescription}</span>
        </div>
      {/if}
    </div>
    {#if description || title || dateFrom || dateTo || time}
      <div class="tile_info position-relative" class:box={box}>
        {#if timeDate}
          <div class="tile_date" class:important_date={importantDate}>
            <span>{timeDate}</span>
          </div>
          {:else}
            {#if dateFrom && dateTo}
              <div class="tile_date" class:important_date={importantDate}>
                <span>{dateFrom}</span>
                <span class="ml-1 mr-1">-</span>
                <span>{dateTo}</span>
              </div>
              {:elseif dateFrom}
                <div class="tile_date" class:important_date={importantDate}>
                  <span>с {dateFrom}</span>
                </div>
            {/if}
        {/if}
        {#if time}
          <div class="tile_time" class:important_date={importantDate}>
            <span class="time">{time}</span>
          </div>
        {/if}
        {#if exchangeTitle}
          {#if title}
            <div class="tile_title">
              <span>{title}</span>
            </div>
          {/if}
          {#if description}
            <div class="tile_info__description {descClassNames || ''}">
              <span>{description}</span>
            </div>
          {/if}
          {:else}
            {#if description}
              <div class="tile_info__description {descClassNames || ''}">
                <span>{description}</span>
              </div>
            {/if}
            {#if title && !titleTop}
              <div class="tile_title">
                <span>{title}</span>
              </div>
            {/if}
        {/if}

        {#if listim_id}
          <div class="wrapper">
            <div class="mt-3 wrapper-button">
              <ListimBtn id={listim_id}>Купить билет</ListimBtn>
            </div>
          </div>
        {/if}
      </div>
    {/if}
  </a>
  {#if hoverType === 'paddings'}
    <div class="bg-paddings"></div>
  {/if}

</div>

<style>
  .tile.scaleHover {
    box-shadow: 0 0 1em transparent;
    transform: scale(1);
    transition: transform 0.3s;
    will-change: transform;
    &:hover {
       transform: scale(1.05);
       box-shadow: 0 0 1em #0000006b;
    }
  }
  .tile {
    .tile_time.important_date,.tile_date.important_date {
      background: #0c6954;
      border: 5px;
      text-align: center;
      padding: 5px;
      font-weight: bold;
      span {
        color: white!important;
      }
    }
    .wrapper {
      &:hover {
        opacity: 1;
      }
      @media(min-width: 1200px) {
        position: absolute;
        width: 100%;
        height: 100%;
        background: transparent;
        bottom: 0;
        opacity: 0;
        transition: opacity 0.3s;
      }
    }
    &:hover {
      .wrapper {
        background: #ececec;
      }
      .bg-paddings {
        opacity: 1;
      }
    }
    .bg-paddings {
      position: absolute;
      width: calc(100% + 40px);
      top: -20px;
      margin-left: -20px;
      margin-right: -20px;
      height: calc(100% + 44px);
      padding: 20px;
      z-index: -1;
      transition: opacity 0.6s;
      will-change: opacity;
      opacity: 0;
      background: #ececec;
    }
  }
  .tile_link {
    &:hover {
      text-decoration: none;
    }
  }

  .tile_img.preload {
     &:before {
        content: '';
        transition: opacity 0.3s;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-position: center;
        background-image: url('/img/icons/preloader.svg');
        background-color: lightgray;
        background-repeat: no-repeat;
     }
  }

  .tile_img.default,
  .tile_img.rectangle,
  .tile_img.square,
  .tile_img.vertical
  {
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: bottom;
    }
  }

  .tile_img.default {
    padding-top: 56.175%;
  }

  .tile_img.rectangle {
    padding-top: 80%;
  }

  .tile_img.square {
    padding-top: 100%;
  }

  .tile_img.vertical {
    padding-top: 141%;
  }

  .tile_img.error {
    padding-top: 56.25%;
    position: relative;
    &:before {
      content: 'Не удалось загрузить изображение :(';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-image: url('/img/default_img.png');
      background-size: cover;
      color: white;
      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
    }
  }
  .tile_img {
    img {
      width: 100%;
    }
    .img-descirption {
      text-transform: uppercase;
      color: white;
      bottom: 30px;
      left: 30px;
      right: 30px;
      font-size: 1.0625rem;
    }
  }


  .tile_info {
    margin-top: 18px;
    line-height: normal;
    .tile_info__description {
      color: #949494;
      font-size: 0.875rem;
      margin-bottom: 14px;
      max-height: calc(6 * 1.375rem);
      overflow: hidden;
      span {
        line-height: 1.375rem;
      }
    }
    .tile_info__description.fs-16 {
      font-size: 1rem;
    }
    .tile_time {
      margin-bottom: 20px;
    }
    .time {
      font-family: Myriad Pro Light;
      color: black;
    }
  }
  .tile_info.box {
    background: white;
    margin-top: 0;
    padding: 20px;
    @media (max-width: 1400px) {
      padding: 10px;
    }
    .tile_info__description {
      span {
        color: black;
        font-size: 0.875rem;
        line-height: 1.375rem;
        text-transform: uppercase;
      }
    }

    .tile_date {
      text-align: right;
      span {
        font-size: 0.875rem;
        color: #949494;
        line-height: 1.375rem;
      }
    }

  }
  .tile_title.height-const {
    height: calc(1.5625rem * 4);
  }
  .tile_title {
    max-height: calc(1.5625rem * 10);
    overflow: hidden;
    span {
      font-size: 1rem;
      letter-spacing: 0.05em;
      line-height: 1.5625rem;
      color: black;
    }
  }
  .tile_date {
    margin-bottom: 20px;
    span {
      font-size: 1.0625rem;
      letter-spacing: 0.05em;
      color: black;
    }
  }
</style>
